import { render } from "./Logo.vue?vue&type=template&id=358e6090&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=358e6090&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358e6090"]])

export default __exports__